import { PageLink } from "../../../_start/layout/core";

export const userManagementSubmenu: Array<PageLink> = [
  {
    title: "Members",
    path: "/user-management/members",
    isActive: true,
  },
  {
    title: "Pending approvals",
    path: "/user-management/pending",
    isActive: false,
  },
];
